<form
  class="lum-c-client-form"
  [formGroup]="formData"
  novalidate
  (ngSubmit)="onSubmit()"
>
  <div class="modal-header">
    <h4 class="modal-title">
      {{ title }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-template #clientInfoFields>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ 'ACCOUNT.BUSINESS_NAME' | translate }}</label>
            <input
              class="form-control"
              type="text"
              placeholder="{{ 'ACCOUNT.BUSINESS_NAME' | translate }}"
              formControlName="business_name"
            />
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.business_name"
            >
            </control-messages>
          </div>
        </div>
        <div class="form-group">
          <label>FEIN</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'ACCOUNT.FEIN' | translate }}"
            formControlName="fein"
            [maxLength]="9"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.fein"
          >
          </control-messages>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ 'ACCOUNT.BUSINESS_TYPE' | translate }}</label>
            <select formControlName="business_type_id" class="form-control">
              <option
                *ngFor="let bt of clientTypeSvc.record$ | async"
                [value]="bt.id"
              >
                {{ bt.type }}
              </option>
            </select>
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.business_type_id"
            >
            </control-messages>
          </div>

          <div class="form-group">
            <mat-checkbox color="primary" formControlName="tax_exempt">
              TAX EXEMPT
            </mat-checkbox>
            <div class="form-group form-inline" *ngIf="!formData.value.tax_exempt">
              <label class="mr-3">Tax Rate Percentage (%)</label>
              <input
                class="form-control"
                type="number"
                placeholder="Tax Rate"
                required
                formControlName="tax_rate"
                min="0"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="">Sales Rep Assignee</label>
            <ng-select
              [items]="salesRepAssignee$ | async"
              [multiple]="true"
              [closeOnSelect]="true"
              [trackByFn]="trackSalesRepAssigneeByFn"
              formControlName="salesRepAssignee"
              [hideSelected]="true"
              [typeahead]="salesRepAssigneeInput$"
              [loading]="salesRepAssigneeLoading$ | async"
            >
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="ng-value-label">
                  {{ item.firstname }} {{ item.lastname }} ({{ item.email }})
                </span>
                <span
                  class="ng-value-icon right"
                  (click)="clear(item)"
                  aria-hidden="true"
                  >×</span
                >
              </ng-template>
              <ng-template
                ng-option-tmp
                let-item="item"
                let-index="index"
                let-search="searchTerm"
              >
                <div>
                  {{ item.firstname }} {{ item.lastname }} ({{ item.email }})
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Notes</label>
            <textarea
              class="form-control"
              formControlName="notes"
              rows="3"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Client Tags</label>
            <ng-select
              [items]="tags"
              formControlName="tags"
              bindValue="id"
              [searchFn]="customTagsSearchFn"
              multiple="true"
            >
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span
                  class="ng-value-icon right"
                  (click)="clear(item)"
                  aria-hidden="true"
                  >×</span
                >
                <span [innerHTML]="item.name" class="d-inline"></span>
              </ng-template>
              <ng-template
                ng-option-tmp
                let-item="item"
                let-index="index"
                let-search="searchTerm"
              >
                <h6 [innerHTML]="item.name"></h6>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <hr />
      <h5>Business Address</h5>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="form-group col-md-6">
              <label>{{ 'ADDRESS.BUSINESS_ADDRESS' | translate }}</label>
              <input
                class="form-control"
                type="text"
                placeholder="{{ 'ADDRESS.BUSINESS_ADDRESS' | translate }}"
                formControlName="business_address"
              />
              <control-messages
                [submitted]="submitted"
                [control]="formData.controls.business_address"
              >
              </control-messages>
            </div>
            <div class="form-group col-md-6">
              <label>{{ 'ADDRESS.BUSINESS_ADDRESS_LINE_2' | translate }}</label>
              <input
                class="form-control"
                type="text"
                placeholder="{{ 'ADDRESS.BUSINESS_ADDRESS_LINE_2' | translate }}"
                formControlName="business_address_line_2"
              />
              <control-messages
                [submitted]="submitted"
                [control]="formData.controls.business_address_line_2"
              >
              </control-messages>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>{{ 'ADDRESS.CITY_ADDRESS' | translate }}</label>
              <input
                class="form-control"
                type="text"
                placeholder="{{ 'ADDRESS.CITY_ADDRESS' | translate }}"
                formControlName="business_city"
              />
              <control-messages
                [submitted]="submitted"
                [control]="formData.controls.business_city"
              >
              </control-messages>
            </div>
            <div class="form-group col-md-6">
              <label>{{ 'ADDRESS.STATE_ADDRESS' | translate }} </label>
              <input
                class="form-control"
                type="text"
                placeholder="{{ 'ADDRESS.STATE_ADDRESS' | translate }}"
                formControlName="business_state"
              />
              <control-messages
                [submitted]="submitted"
                [control]="formData.controls.business_state"
              >
              </control-messages>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>{{ 'ADDRESS.ZIP_CODE' | translate }}</label>
              <input
                class="form-control"
                type="text"
                placeholder="{{ 'ADDRESS.ZIP_CODE' | translate }}"
                formControlName="business_zip"
              />
              <control-messages
                [submitted]="submitted"
                [control]="formData.controls.business_zip"
              >
              </control-messages>
            </div>
            <div class="form-group col-md-6">
              <label>{{ 'ADDRESS.COUNTRY' | translate }}</label>
              <cnc-ui-countries
                [initialValue]="formData?.value?.business_country"
                [required]="true"
                (changeCountry)="onBusinessCountryChange($event)"
              ></cnc-ui-countries>
              <control-messages
                [submitted]="submitted"
                [control]="formData.controls.business_country"
              >
              </control-messages>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label
                >{{ 'CONTACT.PHONE' | translate }}
                {{ 'GENERAL.NUMBER' | translate }}</label
              >
              <input
                class="form-control"
                type="text"
                placeholder="{{ 'CONTACT.PHONE' | translate }} {{
                  'GENERAL.NUMBER' | translate
                }}"
                formControlName="phone"
              />
              <control-messages
                [submitted]="submitted"
                [control]="formData.controls.phone"
              >
              </control-messages>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngFeatureFlag="featureFlag.CUSTOM_FIELDS; isDisabled: false">
        <hr />
        <h5>Custom Fields</h5>
        <lum-custom-field-form-group
          [customFieldObject]="eCustomFieldObject.BUSINESS_ACCOUNT"
          [customFieldValues]="client?.custom_field_values || []"
          (onChange)="onCustomFieldChange($event)"
        ></lum-custom-field-form-group>
      </ng-container>
    </ng-template>

    <div
      *ngTemplateOutlet="!isCreating ? clientInfoFields : null"
      class="pb-4"
    ></div>

    <mat-tab-group
      *ngIf="isCreating"
      #tabGroup
      [selectedIndex]="activeTabIndex"
      (selectedTabChange)="handleSelectedTabChange($event)"
    >
      <mat-tab label="Client Info">
        <div class="lum-c-client-form__tab-content">
          <ng-container [ngTemplateOutlet]="clientInfoFields"></ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Shipping Address" [disabled]="!client?.id">
        <div class="lum-c-client-form__tab-content">
          <div class="row">
            <div class="col-md-12">
              <cnc-shipping-address-inline-table
                [businessAccount]="client"
              ></cnc-shipping-address-inline-table>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Contacts" [disabled]="!client?.id">
        <div class="lum-c-client-form__tab-content">
          <div class="d-flex gap-4">
            <label class="form-group grow">
              <div class="lum-label">Primary Contacts</div>
              <div>
                <ng-select
                  appendTo="body"
                  [placeholder]="
                    contacts.length > 0
                      ? 'Search contacts for this company...'
                      : 'No conctacts have been assigned to this company.'
                  "
                  [items]="contacts"
                  [multiple]="true"
                  [hideSelected]="true"
                  [loading]="clientUserLoading"
                  [searchFn]="clientContactSearch"
                  formControlName="primaryContacts"
                  (add)="updatePrimaryContactsV2($event)"
                  (remove)="onRemove($event)"
                  (clear)="clearPrimaryContacts()"
                >
                  <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span
                      class="ng-valued-icon right"
                      (click)="clear(item)"
                      aria-hidden="true"
                      >×</span
                    >
                    <span>
                      {{ item?.userAccount?.firstName }}
                      {{ item?.userAccount?.lastName }}
                      <small>[{{ item?.userAccount?.email }}]</small>
                    </span>
                  </ng-template>
                  <ng-template
                    ng-option-tmp
                    let-item="item"
                    let-index="index"
                    let-search="searchTerm"
                  >
                    <h6>
                      {{ item?.userAccount?.firstName }}
                      {{ item?.userAccount?.lastName }}
                      <small>[{{ item?.userAccount?.email }}]</small>
                    </h6>
                  </ng-template>
                </ng-select>
              </div>
            </label>
            <button
              type="button"
              class="lum-button lum-button--secondary lum-form__item--emulate-label"
              (click)="addNewContact()"
            >
              <i class="fas fa-plus"></i>
              Add New Contact
            </button>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="lum-button lum-button--secondary"
      (click)="close()"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i>
      Cancel
    </button>
    <button
      type="submit"
      id="kt_submit"
      class="lum-button lum-button--primary kt-btn-primary"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      [translate]="'BUTTONS.SAVE'"
    >
      <i class="fas fa-save"></i>
      {{ activeTabIndex === maxTabIndex ? 'Save' : 'Save and Next' }}
    </button>
  </div>
</form>
